import appConfig from "../config/app.config";
import axios from "axios";
import { getUserToken } from "../libs/user";
const token = getUserToken();
const staticPayLoad = (token) => {
  return new Promise((resolve, reject) => {
    var config = {
      method: "get",
      url: appConfig.apiUrl.staticPayload,
      headers: {
        Authorization: `Bearer ${token}`,
        "accept-language": "en-us",
        "content-type": "application/json",
        accept: " application/json, text/plain, */*",
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const dismissCards = (token, itemId) => {
  // const item = itemId;
  return new Promise((resolve, reject) => {
    const config = {
      method: "put",
      url: appConfig.apiUrl.dismisscard + itemId,
      headers: {
        "access-control-allow-origin": "*",
        Authorization: `Bearer ${token}`,
        "accept-language": "en-GB,en;q=0.9",
        "cache-control": "no-cache, no-store, max-age=0, must-revalidate",
        "content-type": "application/json",
        accept: " application/json, text/plain, */*",
        "Access-Control-Allow-Headers": "Content-Type",
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const plaidgetlinktoken = (token) => {
  // const item = itemId;
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: appConfig.apiUrl.getlinktoken,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
const plaidonsuccess = (
  publicToken,
  authToken,
  fingerprint,
  institution,
  accounts
) => {
  return new Promise((resolve, reject) => {
    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");

    const data = JSON.stringify({
      "public-token": publicToken,
      historical_cashback_reward_api: false,
      makeDefault: false,
      flow: ["REFERRAL_CONNECT_FLOW"],
      metadata: {
        institution,
        accounts,
      },
      transaction_id: userData.txnId || null,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.plaidsuccess,
      headers: {
        Authorization: "Bearer " + authToken,
        "device-id": fingerprint,
        "build-number": "3",
        "app-version": "1.28",
        "accept-language": "en-us",
        "content-type": "application/json",
        accept: "*/*",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const getaddedbank = (token) => {
  // const item = itemId;
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: appConfig.apiUrl.getaddedbank,
      params: {
        credit_card: "true",
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const getCardToken = (token) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: appConfig.apiUrl.cardAddToken,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const addRakutenCard = (publicToken, authToken, fingerprint) => {
  return new Promise((resolve, reject) => {
    const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");

    const data = JSON.stringify({
      "public-token": publicToken,
      historical_cashback_reward_api: false,
      makeDefault: false,
      flow: ["REFERRAL_CONNECT_FLOW"],
      account_addition_type: "rakuten",
      transaction_id: userData.txnId || null,
    });

    const config = {
      method: "post",
      url: appConfig.apiUrl.plaidsuccess,
      headers: {
        Authorization: "Bearer " + authToken,
        "device-id": fingerprint,
        "build-number": "3",
        "app-version": "1.28",
        "accept-language": "en-us",
        "content-type": "application/json",
        accept: "*/*",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

const withdrawalRequest = (txnId) => {
  return new Promise((resolve, reject) => {
    const config = {
      method: "get",
      url: `${appConfig.apiUrl.withdrawalRequest}?transaction-id=${txnId}`,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(reject);
        console.log(error);
      });
  });
};

export {
  staticPayLoad,
  dismissCards,
  plaidgetlinktoken,
  plaidonsuccess,
  getaddedbank,
  getCardToken,
  addRakutenCard,
  withdrawalRequest,
};
